module.exports = __webpack_public_path__ + "CWB0XYA8bzo0kSThX0UTuA.a2647ffe169bbbd94a32.woff2";


//////////////////
// WEBPACK FOOTER
// D:/OficinaVirtual/FrontEndFinamco/EFactoringManager/src/assets/fonts/roboto/CWB0XYA8bzo0kSThX0UTuA.woff2
// module id = ../../../../../src/assets/fonts/roboto/CWB0XYA8bzo0kSThX0UTuA.woff2
// module chunks = styles